import styled from '@emotion/styled';

import Layout, { LAYOUT_AREAS } from './Layout';

import { DESKTOP_MAX_WIDTH, MOBILE_PADDING } from 'theme/spacings';

enum CONTAINED_LAYOUT_VARIABLES {
  contentWidth = '--content-width',
}

const ContainedLayout = styled(Layout)`
  ${CONTAINED_LAYOUT_VARIABLES.contentWidth}: min(${DESKTOP_MAX_WIDTH}px, calc(100vw - ${MOBILE_PADDING *
  2}px));

  grid-template-areas:
    '${LAYOUT_AREAS.HEADER} ${LAYOUT_AREAS.HEADER}  ${LAYOUT_AREAS.HEADER}'
    '.                        ${LAYOUT_AREAS.CONTENT} .                       '
    '${LAYOUT_AREAS.FOOTER} ${LAYOUT_AREAS.FOOTER}  ${LAYOUT_AREAS.FOOTER}';
  grid-template-columns:
    1fr
    var(${CONTAINED_LAYOUT_VARIABLES.contentWidth})
    1fr;

  & > footer {
    padding-right: calc(50% - (var(${CONTAINED_LAYOUT_VARIABLES.contentWidth}) / 2));
    padding-left: calc(50% - (var(${CONTAINED_LAYOUT_VARIABLES.contentWidth}) / 2));
  }
`;

export default ContainedLayout;
